import React from 'react';
import { Skeleton, Stack } from '@mui/material';

const Selector = () => (
  <Skeleton
    data-testid='selector-skeleton' variant='rounded' width='inherit' height='50px'
  />
);
const Calendar = () => (
  <Skeleton
    data-testid='calendar-skeleton' variant='rounded' width='inherit' height='400px'
  />
);

const LegendItem = () => (
  <Stack
    direction='row' spacing='10px'>
    <Skeleton
      data-testid='legend-item-skeleton' variant='circular' width='20px' height='20px'
    />
    <Skeleton
      data-testid='legend-item-skeleton' width='50px' sx={{ fontSize: '16px' }}
    />
  </Stack>
);

const Legend = () => (
  <Stack
    direction='row' spacing='20px'>
    <LegendItem />
    <LegendItem />
    <LegendItem />
  </Stack>
);

const PersonalImpactCalendarSkeleton = () => (
  <Stack
    spacing='20px'>
    <Selector />
    <Calendar />
    <Legend />
  </Stack>
);

export default PersonalImpactCalendarSkeleton;
